// extracted by mini-css-extract-plugin
export default {"root":"ResetPasswordPage_root__0reqF","header":"ResetPasswordPage_header__AIr2U","form-container":"ResetPasswordPage_form-container__8C5jg"};